import { Button } from '@/components/ui/button'

export function PlateOcrFailedPanel({ onTryAgain, onScanCustomerQr, onManualEntry }) {
  return (
    <div className="space-y-3 rounded-xl border border-amber-500/30 bg-amber-500/10 p-4">
      <p className="text-sm font-medium text-foreground">Couldn&apos;t read the licence plate.</p>
      <div className="flex flex-col gap-2">
        <Button type="button" onClick={onTryAgain}>
          Try again
        </Button>
        <Button type="button" variant="secondary" onClick={onScanCustomerQr}>
          Scan Customer QR
        </Button>
        <Button type="button" variant="ghost" onClick={onManualEntry}>
          Enter plate manually
        </Button>
      </div>
    </div>
  )
}

export function PlateNotFoundPanel({ plate, onScanCustomerQr, onTryAgain, onManualEntry }) {
  return (
    <div className="space-y-3 rounded-xl border border-border bg-muted/20 p-4">
      <p className="text-sm font-semibold text-foreground">Vehicle not found</p>
      <p className="text-sm text-muted-foreground">
        We detected: <span className="font-mono font-semibold text-foreground">{plate}</span>
      </p>
      <p className="text-xs text-muted-foreground">
        Scan the customer&apos;s QR code to check them in.
      </p>
      <div className="flex flex-col gap-2">
        <Button type="button" onClick={onScanCustomerQr}>
          Scan Customer QR
        </Button>
        <Button type="button" variant="secondary" onClick={onTryAgain}>
          Try plate again
        </Button>
        <Button type="button" variant="ghost" onClick={onManualEntry}>
          Enter plate manually
        </Button>
      </div>
    </div>
  )
}

export function PlateFoundPanel({
  plate,
  vehicleLabel,
  customerName,
  totalWashes,
  subscriptionActive,
  loyaltyPoints,
  onContinue,
  loading,
}) {
  return (
    <div className="space-y-3 rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-4">
      <p className="text-sm font-semibold text-emerald-800 dark:text-emerald-200">Vehicle found</p>
      <dl className="grid gap-2 text-sm">
        <div>
          <dt className="text-xs uppercase tracking-wide text-muted-foreground">Vehicle</dt>
          <dd className="font-medium text-foreground">{vehicleLabel || '—'}</dd>
        </div>
        <div>
          <dt className="text-xs uppercase tracking-wide text-muted-foreground">Registration</dt>
          <dd className="font-mono font-medium text-foreground">{plate}</dd>
        </div>
        <div>
          <dt className="text-xs uppercase tracking-wide text-muted-foreground">Customer</dt>
          <dd className="font-medium text-foreground">{customerName}</dd>
        </div>
        <div className="grid grid-cols-3 gap-2 pt-1">
          <div>
            <dt className="text-[11px] uppercase tracking-wide text-muted-foreground">Washes</dt>
            <dd className="font-semibold tabular-nums">{totalWashes ?? 0}</dd>
          </div>
          <div>
            <dt className="text-[11px] uppercase tracking-wide text-muted-foreground">Subscription</dt>
            <dd className="font-semibold">{subscriptionActive ? 'Active' : 'None'}</dd>
          </div>
          <div>
            <dt className="text-[11px] uppercase tracking-wide text-muted-foreground">Loyalty</dt>
            <dd className="font-semibold tabular-nums">{loyaltyPoints ?? 0} pts</dd>
          </div>
        </div>
      </dl>
      <Button type="button" className="w-full" onClick={onContinue} disabled={loading}>
        Continue to check in
      </Button>
    </div>
  )
}

export function NewVehicleForCustomerPanel({
  plate,
  onAddVehicle,
  onContinueWithout,
  loading,
}) {
  return (
    <div className="space-y-3 rounded-xl border border-primary/25 bg-primary/5 p-4">
      <p className="text-sm font-semibold text-foreground">New vehicle detected for this customer</p>
      <p className="text-sm text-muted-foreground">
        Registration: <span className="font-mono font-semibold text-foreground">{plate}</span>
      </p>
      <div className="flex flex-col gap-2">
        <Button type="button" onClick={onAddVehicle} disabled={loading}>
          Add vehicle to profile
        </Button>
        <Button type="button" variant="secondary" onClick={onContinueWithout} disabled={loading}>
          Continue without adding
        </Button>
      </div>
    </div>
  )
}
